export default {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore: it's not a real "process," just a placeholder for a replacement
  baseUrl: process.env.BASE_URL,
  captchaSiteKey: "6Lcq0bYgAAAAAKFf_SQeob_0miAAww_viAaFIoZg",
};
